class KlaviyoSubscribe extends HTMLElement {
  connectedCallback() {
    this.querySelector('form').addEventListener('submit', this.#onSubmit.bind(this));
  }

  async #onSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const button = form.querySelector('[type="submit"]');
    const error = this.querySelector('[data-klaviyo-error]');

    button.disabled = true;
    error.hidden = true;

    try {
      const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.dataset.companyId)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Footer signup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: form.elements.email.value,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: this.dataset.listId } } }
          }
        })
      });

      if (!response.ok) {
        throw new Error(`Klaviyo ${response.status}`);
      }

      form.hidden = true;
      this.querySelector('[data-klaviyo-success]').hidden = false;
      document.dispatchEvent(new CustomEvent('vrp:newsletter-signup', { detail: { email: form.elements.email.value } }));
    } catch {
      error.hidden = false;
    } finally {
      button.disabled = false;
    }
  }
}

if (!customElements.get('klaviyo-subscribe')) {
  customElements.define('klaviyo-subscribe', KlaviyoSubscribe);
}
